export default {
    manage_deleteAsset_title: "Delete Asset",
    manage_deleteAssets_title: "Delete Assets",
    manage_deleteAssets_description: "Are you sure you want to delete these assets?",
    manage_deleteAsset_description: "Are you sure want to delete this asset?",
    manage_deleteAsset_successMessage: "Asset deleted",
    manage_deleteAssets_successMessage: "Assets deleted",
    manage_deleteAssets_are_in_use: "It is not possible to delete assets in use",
    manage_deleteAssets_successMessageUpdate: "Assets was deleted successfully",
    manage_deleteAsset_successMessageUpdate: "Asset was deleted successfully",
}